// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.video-content {
  margin-bottom: calc(16 * var(--width-ratio));
}
.video-content .img_container {
  width: calc(375 / var(--base-width) * 100vw);
  height: calc(211 / var(--base-width) * 100vw);
}
.video-content .img_container .myImage {
  width: 100%;
  height: 100%;
  background-position: center !important;
  background-size: cover !important;
}
.video-content .video-duration {
  background-color: var(--ion-color-primary-tint);
  border-radius: 40px;
  color: white;
  padding: 2px 8px 2px 8px;
  position: relative;
  top: calc(-35 * var(--width-ratio));
  margin-left: calc(12 * var(--width-ratio));
}
.video-content .playbutton {
  width: calc(44 * var(--width-ratio));
  height: calc(44 * var(--width-ratio));
  border-radius: 50%;
  background-color: white;
  position: relative;
  top: calc(-60 * var(--width-ratio));
  float: right;
  margin-right: calc(10 * var(--width-ratio));
  --padding-inline-start: unset;
  --padding-inline-end: unset;
  --padding-start: unset;
  --padding-end: unset;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/video-post-list2/video-post-list2.component.scss"],"names":[],"mappings":"AAAA;EACE,4CAAA;AACF;AAEE;EACE,4CAAA;EACA,6CAAA;AAAJ;AAEI;EACE,WAAA;EACA,YAAA;EACA,sCAAA;EACA,iCAAA;AAAN;AAWE;EACE,+CAAA;EACA,mBAAA;EACA,YAAA;EACA,wBAAA;EACA,kBAAA;EACA,mCAAA;EACA,0CAAA;AATJ;AAYE;EACE,oCAAA;EACA,qCAAA;EACA,kBAAA;EACA,uBAAA;EACA,kBAAA;EACA,mCAAA;EACA,YAAA;EACA,2CAAA;EAEA,6BAAA;EACA,2BAAA;EACA,sBAAA;EACA,oBAAA;AAXJ","sourcesContent":[".video-content {\n  margin-bottom: calc(16 * var(--width-ratio));\n  //height: calc(211 / var(--base-width) * 100vw);\n\n  .img_container {\n    width: calc(375 / var(--base-width) * 100vw);\n    height: calc(211 / var(--base-width) * 100vw);\n\n    .myImage {\n      width: 100%;\n      height: 100%;\n      background-position: center !important;\n      background-size: cover !important;\n      // content: url(\"../../../assets/img/sample.png\");\n      // background-image: url(\"/assets/img/sample.png\");\n\n      // border-top-left-radius: 30px;\n      // border-top-right-radius: 30px;\n      // border-bottom-right-radius: 10px;\n      // border-bottom-left-radius: 30px;\n    }\n  }\n\n  .video-duration {\n    background-color: var(--ion-color-primary-tint);\n    border-radius: 40px;\n    color: white;\n    padding: 2px 8px 2px 8px;\n    position: relative;\n    top: calc(-35 * var(--width-ratio));\n    margin-left: calc(12 * var(--width-ratio));\n  }\n\n  .playbutton {\n    width: calc(44 * var(--width-ratio));\n    height: calc(44 * var(--width-ratio));\n    border-radius: 50%;\n    background-color: white;\n    position: relative;\n    top: calc(-60 * var(--width-ratio));\n    float: right;\n    margin-right: calc(10 * var(--width-ratio));\n\n    --padding-inline-start: unset;\n    --padding-inline-end: unset;\n    --padding-start: unset; // 看情況是否右邊要padding否\n    --padding-end: unset; // 看情況是否左邊要padding否\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
